declare const window: any;

export const environment = {
    production: true,
    apiUrl: 'https://app-test.feed-me.it',
    // Use environment variables for all sensitive data
    auth0: {
        domain: 'dev-qqceb1e5zd7iufen.eu.auth0.com',
        clientId: 'CTZTrzuY3GbCrs0D3hPrvga9W0oFJYGO',
        redirectUri:'http://admin-test.feed-me.it/admin/'
    },
    envName: 'TEST'
};
